module.exports = __webpack_public_path__ + "media/images/front/pc/collaboration/my_atopy_line/icon_caution-7eb0f6791318fe0d08d4c5be591d60f1.svg";